import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import Utilities from '@/Utility/Utilities';

export default class LocatorBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.locator = {
            update: (element, valueAccessor, bindings, view, bindingContext) => {
                let name = ko.unwrap(valueAccessor());

                let locator = '';

                if (name != null && typeof name == 'object') {
                    let parent = name.parent;
                    locator = name.name;
                    if (locator != null && locator !== '' && parent != null && parent !== '') {
                        locator = parent + '.' + name;
                    }
                } else if (name != null && Utilities.isFunction(name)) {
                    locator = name();
                } else
                    locator = name;

                if (locator == null || locator === '') {
                    return;
                }

                $(element).attr('data-locator', locator);
            }
        };
    }
}